/* eslint-disable no-unused-vars */
/* eslint-disable default-case */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef,useCallback, useContext } from "react";
import { Input } from "../../../common"
import {getCultureFromLs, storageUtil, parseJwtToken} from '../../../utils/commonFunctions'
import ResizeObserver from 'resize-observer-polyfill';
import moment from "moment-timezone";
import "../../../assets/styles/controlpanel.scss";
import LoadingIn from '../../../assets/loadingIn.gif';
import DOWNLOAD_ICON from "../../../assets/icons/download-master.svg";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { DFPAPIEndpoint, APIEndpoint } from "../../../utils/axios";
import { CalendarCateringScreen } from "./Calender-Catering";
import { useNavigate } from "react-router-dom";
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import {ThemeContext} from '../../../contexts/themeContext';
import Select from 'react-select';
import usePermissions from "../../../utils/userPermissions";
import useToastAssist from '../../../utils/useToastAssist';
import { set, get, del } from 'idb-keyval';
import { AiFillClockCircle } from "react-icons/ai";
import { BiRefresh } from "react-icons/bi";
import { MdEditDocument, MdLock } from "react-icons/md";
import { HiDocumentCheck } from "react-icons/hi2";
import { IoMdCloseCircle } from "react-icons/io";
import { IoWarning } from "react-icons/io5";

const TimeZones = [
  { key:0,value:"localTimezone", label: 'Local Time Zone' },
  { key:1,value: "utc", label: 'UTC' },
]

const editAirports=[ {label: 'Catering Airport', attribute: 'cateringAirport', type: 'selectSearch2', disabled: false, options: [], required: true ,width:'15rem'},]

const sType = localStorage.getItem('sType');
  const DOMAIN = (sType === 'dfp' ? DFPAPIEndpoint : APIEndpoint);

  const META_COMMIT_JOB = {
    pending: { icon: <AiFillClockCircle color= "#0159beff" size={15} />, label: 'In Progress' },
    running: { icon: <BiRefresh color="#4079bbff" size={15}  />, label: 'In Progress' },
    awaiting_review: { icon: <MdEditDocument color="#da820fff" size={15} />, label: 'Pending Finalization' },
    committing: { icon: <MdLock color="#09772eff" size={15} />, label: 'Finalizing' },
    committed: { icon: <HiDocumentCheck color="#078932ff" size={15} />, label: 'Finalized' },
    cancelled: { icon: <IoMdCloseCircle color="#d7381bff" size={15} />, label: 'Cancelled' },
    failed:  { icon: <IoWarning color="#e5d11dff" size={15} />, label: 'Failed' },
  };

export const CalendarControlHomePanelInner = () => {
  const tblRef = useRef(null);
  const toolbarRef = useRef(null);
  const loadingRef = useRef(false)
  const detachAttach=useRef(false);
  const extraHrs = useRef(null);
  const scrollRef = useRef(null);
  const scrollWidthNear = useRef(null);
  const apiTimeOut=useRef(null);
  const navigate = useNavigate();
  const {themedColor} = useContext(ThemeContext);
  const [toolbar, setToolbar] = useState({tailNo:[{key: 0, label: "Select Tail Number", value: 'Select Tail Number'}],baseStn:[{key: 0, label: "Select Catering Airport", value: 'Select Catering Airport'}] ,timezone: '', date: new Date(), groupBy: "Catering Airport" });
  const [message,setMessage]=useState({text:""});
  const [storesList,setStoresList]=useState([]);
  const [airportFields]=useState(editAirports);
  const [tailNumber,setTailNumbers]=useState([]);
  const [isSuperAdmin, setIsSuperAdmin]= useState(false);
  const [state, setState] = useState({ lastAction: null, isOpenMenu: false, saveDfp: false, defaultTimeZone: "", showAirportSelect: false, loadingContexts: false, isEdited: 0, showDialog: '', flightsRows: [], catAirp: "", catAirports: [], contextData: null, cateringSelectX: null, showNoData: false, noDataShow: "", timeZone: [...TimeZones],
  scrollX: 0,
  scrollY: 0,
  restoreScroll: false,
  isLoadingFlights: false,     
  isRefreshLoading: false,
  isDownloadingFlights: false   
   });

  const getSelectedZone = () => {
    const fallback = state?.defaultTimeZone?.split(' ')[0];
    const tz = toolbar?.timezone;
    if (!tz) return fallback;
    if (tz === 'localTimezone') return Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (String(tz).toLowerCase() === 'utc') return 'UTC';
    const named = String(tz).split(' ')[0];
    return moment.tz.zone(named) ? named : fallback;
  };

  const getZonedDayStart = (zone) =>
    moment.tz(moment(toolbar.date).format('YYYY-MM-DD'), 'YYYY-MM-DD', zone).startOf('day');

  const hoverLineRef = useRef(null);
  const hoverTooltipRef = useRef(null);
  const isRestoringStateRef = useRef(false);  
  const isInitialLoadRef = useRef(true);      
  const isManualRefreshRef = useRef(false); 
  const {toastError,toastSuccess} = useToastAssist();



  const { hasPermission: editDFpcalender } = usePermissions('edit', "dfp-calender");
  const { hasPermission: viewcalender } = usePermissions('view', "dfp-calender");
  const { hasPermission: downloadCalender } = usePermissions('download', "dfp-calender");

  
useEffect(() => {
  const initializeState = async () => {
    try {
 
      const savedDate = storageUtil.get('CALENDAR_DATE_KEY', 'session');
      const savedFlights = await get('CALENDAR_FLIGHTS_KEY');

      if (savedDate) {
        setToolbar(prev => ({
          ...prev,
          date: new Date(savedDate)
        }));
        storageUtil.clear('CALENDAR_DATE_KEY', 'session');

        if (savedFlights) {
         
          setState(prev => ({
            ...prev,
            flightsRows: savedFlights,
            showNoData: false,
            noDataShow: savedFlights.length > 0 ? "" : "No Data"
          }));
        }
      }
  
      const storedCreds = localStorage.getItem("login_credentials");
      if (storedCreds) {
        const { data: creds } = JSON.parse(storedCreds) || {};
        const tokenResp = await parseJwtToken(creds);
        if (tokenResp?.userType === 'superAdmin' || tokenResp?.userRole === 'superAdmin-role') {
          setIsSuperAdmin(true);
        }
      }
    } catch (err) {
      console.error("Error initializing state:", err);
    }
  };

  initializeState();
}, []);

useEffect(() => {
  if (!scrollRef.current || !hoverLineRef.current) return;

  const updateCurrentTimeLine = () => {
    const line = hoverLineRef.current;
    const table = scrollRef.current?.querySelector("table");
    if(!table) return;
    const baseOffset = 162;
    const hourWidth = 72;

    const zone = getSelectedZone();
    if (!zone) return;

    const now = moment().tz(zone);

    const startOfDay = getZonedDayStart(zone);

    const diffMinutes = now.diff(startOfDay, "minutes");

    const left = baseOffset + (diffMinutes / 60) * hourWidth;

    line.style.display = "block";
    line.style.left = `${left}px`;
    line.style.top = "0px";
    line.style.height = `${table?.offsetHeight || scrollRef.current.scrollHeight}px`;

    if (hoverTooltipRef.current) {
  
      hoverTooltipRef.current.innerHTML = `
    <div class="time-box">
      <div class="time">${now.format("hh:mm A")}</div>
      <div class="now-text">NOW</div>
    </div>
`;
    }
  };
  setTimeout(updateCurrentTimeLine, 0);
  updateCurrentTimeLine();
  const interval = setInterval(updateCurrentTimeLine, 60000);

  return () => clearInterval(interval);
}, [toolbar.date, toolbar?.timezone, state?.defaultTimeZone, state?.flightsRows, state?.restoreScroll]);

useEffect(() => {

  if (state && state.flightsRows) {
    const defaultOption = {key: 0, label: 'Catering Airport',value: ''};
    let options = [defaultOption];
    let optionsTailNo = [];
    let cateringStation = null;

    if (state.lastAction?.item) {
      if (state.lastAction.contextData) {
        const { flight } = state.lastAction.contextData;
        const tailNumber = state.flightsRows[flight.i]?.tail;
        if (tailNumber && tailNumber.flights.length > 0) {
          cateringStation = tailNumber.flights[0].startAirport?.locationCode;
        }
      }

      state.flightsRows.forEach((flightRow, index) => {
        if (flightRow.primary && flightRow.primary.label !== cateringStation ) {
          options.push({
            key: index + 1,
            label: flightRow.primary.label,
            value: flightRow.primary.label
          });
        }
        if (flightRow.tail || flightRow.catGroups) {
          optionsTailNo.push({
            tail: flightRow.tail,
            primary:flightRow?.primary?flightRow?.primary:null,
            catGroups: flightRow.catGroups
          });
        }
      });

      setState(prevState => ({
        ...prevState,
        catAirports: options,
        tailNos: optionsTailNo
      }));

      airportFields.forEach(field => {
        if (field.attribute === "cateringAirport") {
          field.options = options;
          field.disabled=state?.catAirp.length?false:true
        }
      });
    }
  }

}, [state.lastAction]);

useEffect(() => {
  if (state.restoreScroll && scrollRef.current) {
    scrollRef.current.scrollTo({
      left: state.scrollX,
      top: state.scrollY,
      behavior: "smooth"
    });

    setState((_) => ({ ..._, restoreScroll: false }));
  }
}, [state.restoreScroll, state.scrollX, state.scrollY]);

const handleScroll = (pixel) => {
  if (!scrollRef.current) return;

  const target = parseInt(pixel, 10);
  if (isNaN(target)) return;

  const containerLeft = scrollRef.current.getBoundingClientRect().left + window.scrollX;
  const relativeX = target - containerLeft;

  scrollRef.current.scrollTo({
    left: relativeX,
    behavior: "smooth",
  });

  setState((_) => ({ ..._, cateringSelectX: null }));
};

useEffect(() => {
  if (!message.text && !message.error) return;

  if (message.text) {
    toastSuccess(message.text);
  } 
  else if (message.error) {
    toastError(message.error);
  }

  const timer = setTimeout(() => {
    setMessage({ text: "", error: "" });
  }, 2000);

  return () => clearTimeout(timer);
}, [message.text, message.error, toastSuccess, toastError]);


useEffect(() => {
  const saved = storageUtil.get('CALENDAR_SCROLL_KEY','session');
  if (saved && scrollRef.current && state?.flightsRows?.length) {
    requestAnimationFrame(() => {
      scrollRef.current.scrollTo(saved.x, saved.y);
    });
    storageUtil.clear('CALENDAR_SCROLL_KEY','session');
  }
}, [state?.flightsRows]);

  useEffect(() => {
  const currentRef = tblRef.current;
  let resizeTimeout;

  fetchDataFilters();
  fetchCulureApi();

  const resizeObserver = new ResizeObserver((entries) => {
    cancelAnimationFrame(resizeTimeout);
    resizeTimeout = requestAnimationFrame(() => {
      const { width, height } = entries[0].contentRect;
      setState((_) => ({ ..._, layout: { height, width } }));
    });
  });

  if (currentRef) {
    resizeObserver.observe(currentRef);
  }

  const handleClick = () => {
    setState((_) => ({ ..._, contextData: null, cateringContext: null }));
  };

  document.addEventListener("click", handleClick);

  return () => {
    if (currentRef) {
      resizeObserver.unobserve(currentRef);
    }
    cancelAnimationFrame(resizeTimeout);
    document.removeEventListener("click", handleClick);

    del('flightPlans').catch((error) =>
      console.error("error",error)
    );
    if(loadingRef.current){
      clearTimeout(loadingRef.current);
    }
   
  };
}, []);


  useEffect(() => {
    if (!isInitialLoadRef.current || isRestoringStateRef.current) {
      return;
    }

    if (toolbar?.timezone && toolbar?.date) {
      fetchFlighSchedule();
    }
  }, [toolbar?.timezone]); 
  

  useEffect(() => {

    if (isInitialLoadRef.current || isRestoringStateRef.current) {
      return;
    }

    if (toolbar?.date && toolbar?.timezone) {

      fetchFlighSchedule();
    }
  }, [toolbar?.date]);

  useEffect(() => {

    if (isInitialLoadRef.current || isRestoringStateRef.current) {
      return;
    }

    if (toolbar?.timezone && toolbar?.date) {
 
      fetchFlighSchedule();
    }
  }, [toolbar?.timezone]);


async function filterCalenderData() {
  const flightCal = await get('flightPlans');

  if (flightCal && Array.isArray(flightCal)) {
    let rows = groupSchedules(flightCal);


    if (
      toolbar.tailNo[0] &&
      !toolbar.tailNo[0].label.includes("Select") &&
      !toolbar.tailNo.includes(null)
    ) {
      const filteredGroups = flightCal.filter(
        tNo => getCorrectedTailNo(tNo.tailNumber) === toolbar.tailNo[0].value
      );

      if (filteredGroups.length) {
        rows = groupSchedules(filteredGroups);
        setState((_) => ({ ..._, showNoData: false, noDataShow: "" }));
      } else {
        rows = [];
        setState((_) => ({ ..._, flightsRows: rows.filter(it=>it.flights?.length>0 && it.catGroups?.length>0), showNoData: false, noDataShow: "No Data" }));
        return;
      }
    }


    if (
      toolbar.baseStn[0] &&
      !toolbar.baseStn[0].label.includes("Select") &&
      !toolbar.baseStn.includes(null)
    ) {
      const filteredGroups = flightCal.filter(
        tNo => tNo.startAirport.locationCode === toolbar.baseStn[0].value
      );

      if (filteredGroups.length) {
        rows = groupSchedules(filteredGroups);
        setState((_) => ({ ..._, showNoData: false, noDataShow: "" }));
      } else {
        rows = [];
        setState((_) => ({ ..._, flightsRows: rows.filter(it=>it.flights?.length>0 && it.catGroups?.length>0), showNoData: false, noDataShow: "No Data" }));
        return;
      }
    }

    setState((_) => ({
      ..._,
      flightsRows: rows.filter(it=>it.flights?.length>0 && it.catGroups?.length>0),
      showNoData: false,
      noDataShow: rows.length > 0 ? "" : "No Data"
    }));
  }
}

  useEffect(() => {
      filterCalenderData();
  }, [toolbar?.tailNo,toolbar?.baseStn])

  useEffect(() => {
    if(state && state.defaultTimeZone){
      setToolbar(prev=>{
        return {...prev,timezone:state.defaultTimeZone}
      })
    }
  }, [state?.defaultTimeZone])

  async function fetchCulureApi() {
    try {
      const res = getCultureFromLs();
      if(res && res.timezone){
        setState(prev => {
          const timezonArr = [{ key: 2, value: res.timezone.formattedName, label: res.timezone.formattedName }];
          const updatedTimeZone = [
              ...prev.timeZone.filter(item => item.key !== 2),
              ...timezonArr
          ];

          return {
              ...prev,
              defaultTimeZone:res.timezone?.formattedName,
              timeZone: updatedTimeZone
          };
      });

      }
    } catch (error) {
      console.log(error);
    }
  }

const fetchDataFilters = useCallback(
  async () => {
    try {
      const [resTailNo,respStores] = await Promise.all([
        DOMAIN.get('sandboxing/aircrafts'),
        APIEndpoint.get('stores'),
      ]);
      if (resTailNo.result.length ) {
            const options1 = [];
            resTailNo.result.filter( (fieldValue, index) => {
              options1.push({key: index+1, label: `${fieldValue.value}`, value: `${fieldValue.value}`});
              return fieldValue;
            });
       setTailNumbers(options1)
      }
      if(respStores.result.length){
        const options = [];
        const baseStn = respStores.result.filter((fieldValue, index, self) => {
          return self.findIndex((t) => t.origin === fieldValue.origin) === index;
        }).map((item,index)=>({key: index+1, label:item.origin, value:item.origin}));
        setStoresList([...options,...baseStn]);
      }
    } catch (error) {

    }


  },

  [],
)

const customStyles = {
  option: (defaultStyles, state) => ({
    ...defaultStyles,
    position: "relative",
    zIndex: state.isOpenMenu ? 9999 : null,
    cursor: "default",
    "&:hover": {
      backgroundColor: "#4C5C81",
    },
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 9999, // Set a high z-index for the portal
  }),
  input: (defaultStyles) => ({
        ...defaultStyles,
        color: '#fff',
        }),
        control: (base) => ({
          ...base,
          minHeight: '35px',
          height: '38px',
          borderColor: '#fff',
          border:'0.7px solid #ffff',
          borderRadius: '3px',
          backgroundColor: themedColor.background,
          '&:hover': {
            borderColor: '#fff'
          },
        }),
        placeholder: (provided,state) => ({
          ...provided,
          whiteSpace: 'nowrap',
          overflow:state.isFocused ? '' : 'hidden',
          fontSize:state.isFocused ? '0.9rem' : '',
          textOverflow: 'ellipsis',
          color:  state.isFocused ? '#6e7c84' : '#fff',
        }),
        indicatorSeparator: (provided) => ({
          ...provided,
          display: 'none', // Remove the indicator separator
        }),
        dropdownIndicator: (provided) => ({
          ...provided,
          color: '#fff',
        }),   menuList: (provided) => ({
          ...provided,
          textAlign: "left",
          color: "#fff",
          overflowY: "auto",
          padding: "0",
          margin: "0",
          scrollbarWidth: "thin",
        }), menu: (provided) => ({
          ...provided,
          overflowY: "auto",
          padding: "0",
          margin: "0",
          scrollbarWidth: "thin",
          backgroundColor: themedColor.background,
        }),
};


const getTimeColumns = () => {
  const hours = 37; 

  return new Array(hours).fill('').map((_, i) => {
    const date = moment().startOf('day');
    return {
      label: date.add(i, 'hours').format('HH:mm'),
      value: i
    };
  });
};

  const getEncodedTimezone=(timezoneString)=> {
    if (!timezoneString) return null;

    if (timezoneString.toLowerCase().includes('local')) {
      const localTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const offset = moment().tz(localTz).format('Z'); // Returns format 
      const encodedTime = encodeURIComponent(`T00:00:00${offset}`);

      return encodedTime;
    }

    const parenthesesRegex = /\((?:UTC|GMT)([+-]\d{2}:\d{2})\)/;
    let match = timezoneString.match(parenthesesRegex);
    
    if (match) {
      const timezoneOffset = match[1];
      const encodedTime = encodeURIComponent(`T00:00:00${timezoneOffset}`);
      return encodedTime;
    }
    

    const directRegex = /^(?:UTC|GMT)([+-]\d{2}:\d{2})$/;
    match = timezoneString.match(directRegex);
    
    if (match) {
      const timezoneOffset = match[1];
      const encodedTime = encodeURIComponent(`T00:00:00${timezoneOffset}`);
      return encodedTime;
    }

    try {
      const tzName = timezoneString.split('(')[0].trim(); 
      if (moment.tz.zone(tzName)) {
        const offset = moment().tz(tzName).format('Z');
        const encodedTime = encodeURIComponent(`T00:00:00${offset}`);
        return encodedTime;
      }
    } catch (e) {

    }
    return null;
  }

const fetchFlighSchedule = async () => {
  await del('flightPlans');

  scrollWidthNear.current = null;
  extraHrs.current = 0;

  const date = moment(toolbar.date).format('YYYY-MM-DD');
  const timezoneSel = toolbar?.timezone?.toLowerCase() === 'utc' ? 'UTC (UTC+00:00)' : toolbar?.timezone;
  const localIsoString = getEncodedTimezone(timezoneSel);

  if (toolbar?.timezone && localIsoString) {
    try {

      if (isManualRefreshRef.current) {
        setState((_) => ({
          ..._,
          isRefreshLoading: true,
        }));
      } else {
    
        setState((_) => ({
          ..._,
          isLoadingFlights: true,
        }));
      
      }
      
      const apiUrl = `operations/flightPlans/dates/${date}${localIsoString}`;

      
      const plans = await DFPAPIEndpoint.get(apiUrl);
   

      const flightWithAirports =  plans.flightPlan.groups?.filter(flight => (flight.cateringGroups?.length > 0 && flight.uplifts?.length > 0));
     

      await set('flightPlans', flightWithAirports);

      let rows = groupSchedules(flightWithAirports);
      const filteredRows = rows.filter(it=>it.flights?.length>0 && it.catGroups?.length>0);
      
      setState((_) => ({
        ..._,
        flightsRows: filteredRows,
        showNoData: false,
        isLoadingFlights: false,
        isRefreshLoading: false,
        noDataShow: rows.length > 0 ? "" : "No Data"
      }));
      
 
      await set('CALENDAR_FLIGHTS_KEY', JSON.parse(JSON.stringify(filteredRows)));
      
      if (isManualRefreshRef.current) {
        toastSuccess(`Flight Plans refreshed successfully for ${date}`);
        isManualRefreshRef.current = false; 
      }
      isInitialLoadRef.current = false;
      
    } catch (error) {

      const errorMessage = error.response?.data?.message || error.message || 'Failed to refresh data. Please try again.';
      toastError(`${errorMessage}`);
      
      if(apiTimeOut.current){
        clearTimeout(apiTimeOut.current)
      }
      apiTimeOut.current = setTimeout(()=>{
        setState((_) => ({
          ..._,
          isLoadingFlights: false,
          isRefreshLoading: false,
        }));

        isInitialLoadRef.current = false;
      }, 2500)
    }
  } else {

    setState((_) => ({
      ..._,
      isLoadingFlights: false,
      isRefreshLoading: false,
    }));

    isInitialLoadRef.current = false;
  }
};

 const getCorrectedTailNo = (tNo) => {
  const pattern = /-/;
  if (tNo && tNo.slice(0, 2) === 'VT' && !pattern.test(tNo)) {
    const indeWithT = tNo.indexOf("T");
    if (indeWithT !== -1) {
      return tNo.slice(0, indeWithT + 1) + '-' + tNo.slice(indeWithT + 1);
    }
  }
  return tNo ?? "--";
};

const getDateFromTimezone = (dateTimestr) => {
  if (!dateTimestr) return null;

  const localTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
 const defaultTimezone = state?.defaultTimeZone?.split(' ')[0];

  if (String(toolbar?.timezone).toLowerCase() === 'utc') {
    return moment.utc(dateTimestr);
  }

  if (toolbar?.timezone === 'localTimezone') {
    return moment.utc(dateTimestr).tz(localTz);
  }

  const selectedTz = toolbar?.timezone?.split(' ')[0];
  if (selectedTz) {
    return moment.utc(dateTimestr).tz(selectedTz);
  }

  return moment.utc(dateTimestr);
};




const getDateStart = (iDate) => {

 const zone = getSelectedZone();

 if (!zone) {
   return moment(iDate, "DD/MM/YYYY").startOf("day");
 }

 const dateStart = getZonedDayStart(zone);

 if (!dateStart.isValid()) {
   return moment(iDate, "DD/MM/YYYY").startOf("day");
 }

 return dateStart;
};


  const groupSchedules = (flights) => {
    let groups = {}, rows = [],
      sorter = (attribute, itemA, itemB) => {
        const valueA = itemA[attribute].toLowerCase();
        const valueB = itemB[attribute].toLowerCase();
        return valueA < valueB ? -1 : (valueA > valueB ? 1 : 0);
      },

    getWidthLeft = (startTime, endTime) => {
      if (!startTime || !endTime) {
        return { width: 0, left: 0, diff: 0, offset: 0 };
      }

      if (!moment.isMoment(startTime)) {
        startTime = moment(startTime);
      }
      if (!moment.isMoment(endTime)) {
        endTime = moment(endTime);
      }

      if (!startTime.isValid() || !endTime.isValid()) {
        return { width: 0, left: 0, diff: 0, offset: 0 };
      }

      const defaultTimezone = state?.defaultTimeZone?.split(' ')[0];
      if (!defaultTimezone) {
        return { width: 0, left: 0, diff: 0, offset: 0 };
      }

 
      const zone = getSelectedZone() || defaultTimezone;

      let hourWidth = 72;
      let baseOffset = 162;

      let timelineStart = getZonedDayStart(zone);

      startTime = startTime.clone().tz(zone);
      endTime   = endTime.clone().tz(zone);

      let diff = endTime.diff(startTime, 'minutes');
      let width = (diff / 60) * hourWidth;

      let startOffsetHrs = startTime.diff(timelineStart, 'minutes') / 60;
      let left = (startOffsetHrs * hourWidth) + baseOffset;

      return { width, left, diff, offset: startOffsetHrs };
    };


    flights.forEach((_) => {
      let mainGroup, secondaryCrp, startAirport = _.startAirport?.locationCode;
      mainGroup = toolbar.groupBy === "Catering Airport" ? startAirport : getCorrectedTailNo(_.tailNumber);
      secondaryCrp = toolbar.groupBy === "Catering Airport" ?  getCorrectedTailNo(_.tailNumber) : startAirport;

      if (!groups[mainGroup]) {
        groups[mainGroup] = {}
      }

      if (!groups[mainGroup][secondaryCrp]) {

        groups[mainGroup][secondaryCrp] = []
      }

      groups[mainGroup][secondaryCrp].push(_)

    })

    groups = Object.keys(groups).map((key) => {

      let group = { group: key, count: 0 }
      group.secondary = Object.keys(groups[key]).map((secKey) => {

        let flights = groups[key][secKey];
        flights.sort((flightA, flightB) => {
          let startA = getDateFromTimezone(flightA?.startTime, true),
            startB = getDateFromTimezone(flightB?.startTime, true);
          return startA?.isBefore(startB) ? -1 : (startA?.isAfter(startB) ? 1 : 0)
        })
        group.count += flights.length;
        return { group: secKey, flights }
      })
      group.secondary.sort(sorter.bind(null, 'group')
    )
      return group
    })

    groups.sort(sorter.bind(null, 'group'))
    groups.forEach((group, i) => {
      group.secondary.forEach((tail, j) => {
      let  flights = [], catGroups = [], row;
  tail.flights.forEach((flight) => {
    const {name, id, commitOrchestrationJob}=flight;
  if (!flight.uplifts || flight.uplifts.length === 0) return;
  if( flight.uplifts.length === 1 && (flight.uplifts[0].type==='topup'||flight.uplifts[0].type==='preBooked'))return;
  
  const upliftMapped = new Map(
    flight.uplifts.map(item => [item.sectorId, item.type])
  );

  let previousCatGroup = null;


flight.cateringGroups.forEach((g) => {
  let cateringStart, cateringEnd, resSectors = [];
  let catGroupInd = g.uplift?.storeName
    ? `${g.uplift.storeName}/${(g.name ?? '').split('/')[0]}`
    : g.sectors[0]?.id;

  g.baseGroup =
    upliftMapped.get(catGroupInd ?? null) === "topup" ||
    upliftMapped.get(catGroupInd ?? null) === "preBooked";

  g.groupName = name;
  g.widthAdj = false;

  g.sectors.forEach((sector) => {
    let startTime, endTime;

    if (sector.etd && sector.eta) {
      startTime = getDateFromTimezone(sector.etd);
      endTime = getDateFromTimezone(sector.eta);
    } else if (sector.atd && sector.ata) {
      startTime = getDateFromTimezone(sector.atd);
      endTime = getDateFromTimezone(sector.ata);
    } else if (sector.rtd && sector.rta) {
      startTime = getDateFromTimezone(sector.rtd);
      endTime = getDateFromTimezone(sector.rta);
    } else if (sector.std && sector.sta) {
      startTime = getDateFromTimezone(sector.std);
      endTime = getDateFromTimezone(sector.sta);
    }

    if (startTime && endTime) {
      const dayStart = getDateStart(toolbar.date);
      const dayEnd = dayStart ? dayStart.clone().add(37, "hours") : null;

      if (!dayStart || !dayEnd) return;
      

      if (!moment.isMoment(startTime) || !startTime.isValid() || !moment.isMoment(endTime) || !endTime.isValid()) {
        return;
      }

      if (startTime.isBefore(dayStart)) startTime = dayStart.clone();
      if (endTime.isAfter(dayEnd)) endTime = dayEnd.clone();
      if (endTime.isBefore(dayStart) || startTime.isSameOrAfter(dayEnd)) return;

      const { width, left } = getWidthLeft(startTime, endTime);
      const diffWidth = Math.floor(left - width);

      if (
        scrollWidthNear.current === null ||
        diffWidth < scrollWidthNear.current
      ) {
        scrollWidthNear.current = diffWidth;
        handleScroll(scrollWidthNear.current);
      }
      resSectors.push({ width, left, item: sector, startTime, endTime });
    }
  });

  
  if (resSectors.length > 0) {
    flights = flights.concat(resSectors); 
    cateringStart = resSectors[0].startTime;
    cateringEnd = resSectors[resSectors.length - 1].endTime;

    const { width, left } = getWidthLeft(cateringStart, cateringEnd);
    const catGroupObj = { width, left, item: { ...g, groupId: id, commitOrchestrationJob } };

    if (g.baseGroup && previousCatGroup && !previousCatGroup.item.baseGroup) {
      const newWidth = catGroupObj.left - previousCatGroup.left;
      previousCatGroup.width = newWidth > 0 ? newWidth : previousCatGroup.width;
      previousCatGroup.item.widthAdj = true;
    }

    catGroups.push(catGroupObj);
    previousCatGroup = catGroupObj;
  }
});


});

        row = { flights, catGroups, tail };
        if (j === 0) {
          row.primary = { label: group.group, count: group.secondary.length }
        }
        rows.push(row);
      })
    });
    return rows
  }

  const handleInputChange = (e) => {
    let { name, value } = e.target;

    if(!value && name==="date"){
      setToolbar((prev)=>{
        return {...prev,date:new Date()}
      })
    }
    if(!value) return;
    if (name === 'date' && value) {
      value = getDateFromTimezone(value).toDate()
    }

    setToolbar((_) => ({ ..._, [name]: value }));
    setState((_) => ({ ..._, lastAction: null,saveDfp:false }))
  }
const handletailNumberSel=(e)=>{
  setToolbar(_prev => {
    return {
      ..._prev,
      tailNo:[e],

    }
  })
}
const handleBaseStaationSel=(e)=>{
  setToolbar(_prev => {
    return {
      ..._prev,
      baseStn:[e],

    }
  })
}
  const handleDialog = (dialogId) => {
    setState((_) => ({ ..._, showDialog: dialogId }))
  }

 const handleContextMenu = (flight, row, e) => {
  e.preventDefault();

  let points = { x: e.pageX, y: e.pageY }
  const screenHeight = window.innerHeight

  if (+screenHeight - +e.pageY < 250) {
    points.y = +e.pageY - 80
  }

  setState((_) => ({
    ..._,
    cateringContext: {
      points,
      sector: {
        flightNumber: flight.item?.key || '',
        origin: flight.item?.origin || '',
        destination: flight.item?.destination || '',
        flightDate: flight.item?.flightDate || flight.item?.flightDateUTC || '',
        flightDatePortLocal: flight.item?.flightDatePortLocal || ''
      }
    },
    contextData: null,
    cateringSelectX: e.pageX
  }));
}



const handleCateringContextMenu = (groups, j, tailNr, e) => {
  e.preventDefault();
  
  const groupId = groups[j]?.item?.groupId;
  const filteredGroups = groups.filter(g => g?.item?.groupId === groupId);

  let points = { x: e.pageX, y: e.pageY }
  const screenHeight = window.innerHeight

  if (+screenHeight - +e.pageY < 250) {
    points.y = +e.pageY - 80
  }

  setState((_) => ({
    ..._,
    cateringContext: {
      points,
      filteredGroups,
      tailNumber: tailNr,
      cateringGroup: groups[j]?.item  //  catering group
    },
    contextData: null,
    cateringSelectX: e.pageX
  }));
}

  const getSelectedItem = (i, j) => {
    let sector, sectorIndex, catGrp, catGroupIndex;
    const flightsRows = state.flightsRows
    if (i === undefined && j === undefined) {
      i = state.contextData.flight.i;
      j = state.contextData.flight.j;
    }
    const row = flightsRows[i];
    sector = row.flights[j];
    catGroupIndex = flightsRows[i].catGroups.findIndex(({ item }) => {
      return item.sectors.findIndex((_) => (_.key === sector.item.store?.name)) > -1
    });

    catGrp = flightsRows[i].catGroups[catGroupIndex];
    sectorIndex = catGrp?.item?.sectors.findIndex((_) => (_.store?.name === sector.item?.store.name));
    return { sector, catGrp, sectorIndex, catGroupIndex };
  }

  const getContextMenuItems = () => {
    let menus = [], { i, j } = state.contextData.flight
    const flightsRows = state.flightsRows
    const { catGroupIndex } = getSelectedItem();
    // both attach or detach
    [-1, 1].forEach((index) => {
      if (flightsRows[i].flights[j + index]) {
        let flightDetails = getSelectedItem(i, j + index);
        let flightDetailsDetach = getSelectedItem(i, j );
        let direction = index === -1 ? 'left' : 'right'
        if (flightDetails.catGroupIndex === catGroupIndex) {
          menus.push({ action: 'detach', flightDetails:{...flightDetailsDetach,detachIndex:i}, direction: direction, label: `Detach from ${flightDetails.sector.item.store?.name}` })
        } else {
          menus.push({ action: 'attach', flightDetails:{...flightDetailsDetach,detachIndex:i}, direction: direction, label: `Attach with ${flightDetails.sector.item.store?.name}` })
        }
      }
    })
    return menus
  }
const getCateringContextMenuItems = () => {
  const groups = state.cateringContext?.filteredGroups;
  if (!groups?.length) return [];

  const hasMealOrder = groups.some(group =>
    group.item?.estimates?.some(est => est.relativeExecutionOffset === 4)
  );

  const commitOrchestrationJob = groups[0]?.item?.commitOrchestrationJob;
  const isCommitted = commitOrchestrationJob?.isolateId;

const groupDate = groups[0]?.item?.date || groups[0]?.item?.startTime;
  const isFutureDate = groupDate  ? moment(groupDate).startOf('day').isAfter(moment().startOf('day')) : false;  // finding the current date---
const jobStatus = commitOrchestrationJob?.status;

let finalizeItems = [];

if (jobStatus === 'failed') {
  finalizeItems = [
    { label: "Finalize Rotation", action: 'finalize-rotation', commitOrchestrationJob },
    { label: "View Rotation", action: 'view-rotation', commitOrchestrationJob }
  ];
}
else if (isCommitted) {
  finalizeItems = [
    { label: "View Rotation", action: 'view-rotation', commitOrchestrationJob }
  ];
}

else if (!isFutureDate) {
  finalizeItems = [
    { label: "Finalize Rotation", action: 'finalize-rotation', commitOrchestrationJob }
  ];
}

const menus = [
  ...finalizeItems,
  { label: "Summary",   action: 'summary'   },
  { label: "Estimates", action: 'estimates' },
  { label: "Uplifts",   action: 'uplifts'   },
  { label: "Retrieval", action: 'retrieval' },
];

  if (hasMealOrder) {
    menus.splice(2, 0, { label: "Meal Order",  action: 'meal-order'    });
    menus.splice(3, 0, { label: "Invoice",     action: 'invoice-menu'  });
  }

  return menus;
};

const getFlightContextMenuItems = () => {
  return [
    { label: "PAX Manifest", action: 'pax-manifest' }
  ];
}


const getCommitJobMeta = (job) => {
  if (!job) return null;
  return META_COMMIT_JOB[job.status] || null;
};


  const getCaterGroupWidthLeft = (cat, i) => {
    const flightsRows = JSON.parse(JSON.stringify(state.flightsRows));
    let startSector = cat.item.sectors[0], endSector = cat.item.sectors[cat.item.sectors.length - 1];
    startSector = flightsRows[i].flights.find(({ item }) => (item.store?.name === startSector.store?.name))
    endSector = flightsRows[i].flights.find(({ item }) => (item.store?.name === endSector.store?.name));
    cat.left = startSector?.left;
    cat.width = (endSector?.left + endSector?.width) - startSector?.left;
  }

  const cateringGroupNames=(sectData)=>{
    if(sectData&&sectData.length){
      const flightDate = new Date( sectData[0].flightDateUTC);
      const sequence =  sectData.map(flight => flight.origin).join('-') + '-' +  sectData[ sectData.length - 1].destination;
      return `${flightDate.getFullYear()}-${(flightDate.getMonth() + 1).toString().padStart(2, '0')}-${flightDate.getDate().toString().padStart(2, '0')}/${sequence}`;
    }
  }
  const handleMergeFlight = async(item, e) => {

    let contextData = state.contextData, lastAction = null;
    if (!contextData && state.lastAction) {
      contextData = state.lastAction.contextData
    } else {
      lastAction = { contextData, item }
    }

    const { i, j } = contextData.flight;

    if(true){
    if (e && typeof e.stopPropagation === 'function') {
    e.stopPropagation();
    setState((_) => ({ ..._, contextData: null ,detachedSector:item.flightDetails?.sector,isEdited:_.isEdited+1}))
    }else{
      setState((_) => ({ ..._, contextData: null ,detachedSector:item.flightDetails?.sector,isEdited:_.isEdited>0?_.isEdited-1:_.isEdited}))
    }
    const flightsRows = JSON.parse(JSON.stringify(state.flightsRows));
    const { action, direction } = item;
    const { sector, catGrp, catGroupIndex, sectorIndex } = getSelectedItem(i, j)
    if (action === 'detach') {
      detachAttach.current = false;
      let fromIndex, gap, nameCatGrNew, nameCatGr, detachFrom, newCatGroup = { item: JSON.parse(JSON.stringify(catGrp.item)) }, sectors = [...catGrp.item.sectors];
      if (direction === 'right') {
        fromIndex = j + 1;
        detachFrom = flightsRows[i].flights[fromIndex]
        gap = detachFrom.left - sector.left - sector.width;
        catGrp.item.sectors = sectors.slice(0, sectorIndex + 1);
        newCatGroup.item.sectors = sectors.slice(sectorIndex + 1);
        nameCatGrNew=cateringGroupNames(sectors.slice(sectorIndex + 1))
        nameCatGr=cateringGroupNames(sectors.slice(0,sectorIndex + 1))
        newCatGroup.item.name=nameCatGrNew;
        catGrp.item.name=nameCatGr;

      } else {
        fromIndex = j - 1;
        detachFrom = flightsRows[i].flights[fromIndex]
        gap = sector.left - detachFrom.left - detachFrom.width
        newCatGroup.item.sectors = sectors.slice(0, sectorIndex);
        catGrp.item.sectors = sectors.slice(sectorIndex);
        nameCatGrNew=cateringGroupNames(sectors.slice(0,sectorIndex))
        nameCatGr=cateringGroupNames(sectors.slice(sectorIndex))
        newCatGroup.item.name=nameCatGrNew;
        catGrp.item.name=nameCatGr;

      }
      getCaterGroupWidthLeft(catGrp, i)
      getCaterGroupWidthLeft(newCatGroup, i)
      flightsRows[i].catGroups[catGroupIndex] = catGrp;

      if (direction === 'right') {
        flightsRows[i].catGroups.splice(catGroupIndex, 0, newCatGroup)
      } else {
        if (catGroupIndex === 0) {
          flightsRows[i].catGroups.unshift(newCatGroup)
        } else {
          flightsRows[i].catGroups.splice(catGroupIndex - 1, 0, newCatGroup)
        }
      }
    } else if (action === 'attach') {
      detachAttach.current = false;
      let target = direction === 'right' ? j + 1 : j - 1;
      target = getSelectedItem(i, target)
      let targetCat = target.catGrp;
      let catrNames;
      if (direction === 'right') {
        targetCat.width = (targetCat?.width + targetCat?.left) - catGrp?.left;
        targetCat.left = catGrp?.left;
        targetCat.item.sectors = [...catGrp?.item?.sectors, ...targetCat?.item?.sectors,]
        catrNames= cateringGroupNames(targetCat?.item?.sectors);
         if(catrNames){
          targetCat.item.name=catrNames;
        }

      } else {

        targetCat.width = (catGrp?.width + catGrp?.left) - targetCat?.left;
        targetCat.item.sectors = [...targetCat.item?.sectors, ...catGrp.item?.sectors,]
        catrNames=cateringGroupNames(targetCat?.item?.sectors);
        if(catrNames){
          targetCat.item.name=catrNames;
        }
      }

      flightsRows[i].catGroups[target.catGroupIndex] = targetCat;
      flightsRows[i].catGroups.splice(catGroupIndex, 1);
    }

    setState((_) => ({ ..._, flightsRows: flightsRows,lastAction: lastAction }));}

  }

  const getEstimateTitleTop = (estimate) => {
    const date = moment(estimate.scheduledTimeOfExecution).tz(moment.tz.guess()).format("DD-MM-YYYY hh:mm");
    return `${date} - ${estimate.relativeExecutionTime}`
  }

//   const removeDuplicatesInSections = (array) =>{
//     let result = [];
//     let section = [];

//     for (const item of array) {

//         if (item.primary) {
//             if (section.length > 0) {

//                 const uniqueTailGroups = new Set();
//                 section = section.filter(sectionItem => {
//                     const tailGroup = sectionItem.tail.group;
//                     if (uniqueTailGroups.has(tailGroup)) {
//                         return false;
//                     }
//                     uniqueTailGroups.add(tailGroup);
//                     return true;
//                 });


//                 if (result.length > 0 && result[result.length - 1].primary) {
//                     result[result.length - 1].primary.count = section.length+1;
//                 }


//                 result = result.concat(section);
//                 section = [];
//             }

//             result.push(item);
//         } else {
//             section.push(item);
//         }
//     }
//     if (section.length > 0) {
//         const uniqueTailGroups = new Set();
//         section = section.filter(sectionItem => {
//             const tailGroup = sectionItem.tail.group;
//             if (uniqueTailGroups.has(tailGroup)) {
//                 return false;
//             }
//             uniqueTailGroups.add(tailGroup);
//             return true;
//         });

//         if (result.length > 0 && result[result.length - 1].primary) {
//             result[result.length - 1].primary.count = section.length+1;
//         }

//         result = result.concat(section);
//     }

//     return result;

// }


// const getModifedCatgroupWidth=(flightsArr)=>{
//     let gap,catWdth,storeNames,sectorsNew,catLeft;
//     const {catGrp}=state.lastAction.item.flightDetails;
//     const {direction}=state.lastAction.item;
//     const {sectors}=catGrp.item;
//     if(sectors && sectors.length>=2){
//         storeNames= cateringGroupNames(sectors);
//         const resArr = flightsArr.reduce((acc, fl) => {
//             if (fl.item.id === sectors[0].id || fl.item.id === sectors[1].id) {
//                 acc.push(fl);
//             }
//         return acc;
//         }, []);
//         sectorsNew=sectors.slice(1);
//         if(resArr && resArr.length>1){
//         gap=(resArr[1].left-resArr[0].left)-resArr[0]?.width;
//         catWdth = direction === 'right' ? catGrp?.width-(gap+resArr[1]?.width) : catGrp?.width-(gap+resArr[0]?.width);
//         catLeft = direction === 'right' ? resArr[0].left : resArr[1].left;
//         }
//     }
//     else{
//         storeNames= cateringGroupNames(sectors);
//         sectorsNew=sectors
//         catWdth=catGrp?.width
//         catLeft=catGrp?.left;

//     }
//         return {catWdth,catLeft,storeNames,sectorsNew};
// }




  const downloadTroleyPlan = async (estimateId) => {
    const { group } = state.cateringContext;
    let mealOrder = group.estimates.find((est) => est.relativeExecutionOffset === 4);



    const path = DFPAPIEndpoint.getFullPath(
      `operations/cateringGroups/${group.id}/estimates/${mealOrder.id}/download`
    );
    let headers = DFPAPIEndpoint.getHeaders();
    headers = headers.headers;

    try {
      const res = await fetch(path, {
        method: "GET",
        headers: headers,
      });
      if (res.status === 200) {
        const file = await res.blob();
        saveAs(file, `${group.plan}_${getEstimateTitleTop(mealOrder)}.xlsx`);
      } else {
       setMessage({error:'Failed to Download Meal Order'})
       setTimeout(() => {
       setMessage({text:""})
       }, 1800);
      }
    } catch (error) {
      setMessage({error:'Failed to Download Meal Order'})
      setTimeout(() => {
      setMessage({text:""})
        }, 1800);
    }

  };

const SHEET_HEADERS = [
  'Flight Date',
  'Catering Airport',
  'Tail Number',
  'Catering Group Name',
  'Sectors',
  'Flight Number',
  'Flight Start Time',
  'Flight End Time',
  'Timezone'
];

// Excel sheet names: max 31 chars, no  : \\ / ? * [ ]
const toSheetName = (raw, used) => {
  let name = String(raw || 'Sheet').replace(/[:\\/?*[\]]/g, '-').trim().slice(0, 31) || 'Sheet';
  if (used.has(name)) {
    let n = 2;
    let candidate = `${name.slice(0, 28)} #${n}`;
    while (used.has(candidate)) {
      n += 1;
      candidate = `${name.slice(0, 28)} #${n}`;
    }
    name = candidate;
  }
  used.add(name);
  return name;
};

const downloadDFPCSV = async () => {
  if (state.isDownloadingFlights) return;
  try {
    if (!state.flightsRows || state.flightsRows.length === 0) {
      toastError('No flight data available to download');
      return;
    }

    setState((prev) => ({ ...prev, isDownloadingFlights: true }));
    await new Promise((resolve) => setTimeout(resolve, 2100));
 
    const formatSectorTime = (iso) => {
      if (!iso) return '';
      const tz = toolbar?.timezone;
      if (!tz || String(tz).toLowerCase() === 'utc') {
        return moment.utc(iso).format('HH:mm');
      }
      const zone = String(tz).toLowerCase().includes('local')
        ? Intl.DateTimeFormat().resolvedOptions().timeZone
        : String(tz).split(' ')[0];
      if (zone && moment.tz.zone(zone)) {
        return moment.utc(iso).tz(zone).format('HH:mm');
      }
 
      const offsetMatch = String(tz).match(/(?:UTC|GMT)\s*([+-]\d{2}:\d{2})/i);
      if (offsetMatch) {
        return moment.utc(iso).utcOffset(offsetMatch[1]).format('HH:mm');
      }
      return moment.utc(iso).format('HH:mm');
    };

    const dataRows = [];
 
    let currentAirport = 'N/A';

    state.flightsRows.forEach((row) => {
      if (row.primary?.label) {
        currentAirport = row.primary.label;
      }
      const airport = currentAirport;

      if (row.catGroups && row.catGroups.length > 0) {
        row.catGroups.forEach((catGroup) => {
          const sectors = catGroup.item?.sectors || [];

 
          if (sectors.length === 0) {
            dataRows.push([
              moment(toolbar.date).format('YYYY-MM-DD'),
              airport,
              row.tail?.group || 'N/A',
              catGroup.item?.groupName || 'N/A',
              'N/A',
              'NA',
              '',
              '',
              toolbar.timezone || 'N/A',
            ]);
            return;
          }

          sectors.forEach((sector) => {
            dataRows.push([
              moment(toolbar.date).format('YYYY-MM-DD'),
              airport,
              row.tail?.group || 'N/A',
              catGroup.item?.groupName || 'N/A',
              `${sector.origin}-${sector.destination}`,
              sector.flightNumber || 'NA',
              formatSectorTime(sector.std),
              formatSectorTime(sector.sta),
              toolbar.timezone || 'N/A',
            ]);
          });
        });
      } else {
        dataRows.push([
          moment(toolbar.date).format('YYYY-MM-DD'),
          airport,
          row.tail?.group || 'N/A',
          'No data',
          '',
          '',
          '',
          '',
          toolbar.timezone || 'N/A',
        ]);
      }
    });
 
    const airportBuckets = new Map();
    dataRows.forEach((r) => {
      const key = r[1] && r[1] !== 'N/A' ? r[1] : 'Unassigned';
      if (!airportBuckets.has(key)) { airportBuckets.set(key, []); }
      airportBuckets.get(key).push(r);
    });

    const workbook = XLSX.utils.book_new();
    const usedNames = new Set();
    const colWidths = [
      { wch: 12 }, { wch: 16 }, { wch: 13 }, { wch: 38 }, { wch: 12 },
      { wch: 13 }, { wch: 17 }, { wch: 16 }, { wch: 28 }
    ];

    const addSheet = (title, rows) => {
      const sheet = XLSX.utils.aoa_to_sheet([SHEET_HEADERS, ...rows]);
      sheet['!cols'] = colWidths;
      XLSX.utils.book_append_sheet(workbook, sheet, toSheetName(title, usedNames));
    };
 
    Array.from(airportBuckets.keys())
      .sort((a, b) => {
        if (a === 'Unassigned') return 1;
        if (b === 'Unassigned') return -1;
        return a.localeCompare(b);
      })
      .forEach((airport) => {
        addSheet(airport, airportBuckets.get(airport));
      });

    const summaryRows = [
      ['Summary', ''],
      ['Total Rows', dataRows.filter(r => r[3] !== 'No data').length],
      ['Total Catering Groups', new Set(dataRows.filter(r => r[3] !== 'No data').map(r => r[3])).size],
      ['Total Airports', airportBuckets.size],
      ['Total Aircraft', new Set(dataRows.map(r => r[2])).size],
      ['Export Date', moment().format('YYYY-MM-DD HH:mm:ss')],
      ['Date', moment(toolbar.date).format('YYYY-MM-DD')],
      ['Timezone', toolbar.timezone || 'Not Set'],
    ];
    const summarySheet = XLSX.utils.aoa_to_sheet(summaryRows);
    summarySheet['!cols'] = [{ wch: 28 }, { wch: 30 }];
    XLSX.utils.book_append_sheet(workbook, summarySheet, toSheetName('Summary', usedNames));

    const buffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    saveAs(blob, `flights-plan-${moment(toolbar.date).format('YYYY-MM-DD')}.xlsx`);

    toastSuccess(`flights-plan Downloaded Successfully`);

  } catch (error) {
    console.error('Excel Download Error:::', error);
    toastError('Failed to download.');
  } finally {
    setState((prev) => ({ ...prev, isDownloadingFlights: false }));
  }
};

const handleCateringClick = async (menu) => {
  loadingRef.current = null;
  if (menu?.action === 'pax-manifest') {
    try {
      const sector = state.cateringContext?.sector;
      
      if (!sector) {
        setMessage({ error: 'No sector data found.' });
        loadingRef.current = setTimeout(() => {
          setMessage({ text: '' });
        }, 1800);
        return;
      }
  
      setState((_) => ({
        ..._,
        prevLayout: _.layout,
        cateringContext: null,
        scrollX: scrollRef.current ? scrollRef.current.scrollLeft : 0,
        scrollY: scrollRef.current ? scrollRef.current.scrollTop : 0,
        seletecCateringGroup: {
          item: 'pax-manifest',
          selectedView: 'pax-manifest',
          sector: sector
        }
      }));
    } catch (error) {

      setMessage({ error: 'Failed to open PAX Manifest.' });
      loadingRef.current = setTimeout(() => {
        setMessage({ text: '' });
      }, 1800);
    }
    return;
  } 
  const groups = state.cateringContext?.filteredGroups;

  if (!groups?.length) return;
  const cateringGroup = groups[0].item;


  if (menu?.action === 'view-rotation') {
    const { isolateName, isolateId } = menu.commitOrchestrationJob;
    setState((_) => ({ ..._, cateringContext: null }));
    storageUtil.set('CALENDAR_DATE_KEY', toolbar.date, 'session');
    await set('CALENDAR_FLIGHTS_KEY', JSON.parse(JSON.stringify(state.flightsRows)));
    storageUtil.set('CALENDAR_SCROLL_KEY', {
      x: scrollRef.current?.scrollLeft || 0,
      y: scrollRef.current?.scrollTop  || 0
    }, 'session');
    navigate(
      `/sales/dynamic/sector/containerIsolate/${encodeURIComponent(isolateName)}/${isolateId}`,
      { state: { viewMode: true, name: isolateName, id: isolateId } }
    );
    return;
  }

  if (menu?.action === 'uplifts' || menu?.action === 'retrieval') {
    setState((_) => ({
      ..._,
      prevLayout: _.layout,
      cateringContext: null,
      scrollX: scrollRef.current ? scrollRef.current.scrollLeft : 0,
      scrollY: scrollRef.current ? scrollRef.current.scrollTop  : 0,
      seletecCateringGroup: { item: menu.action, selectedView: menu.action, group: cateringGroup }
    }));
    return;
  }

  if (menu?.action === 'summary') {
    setState((_) => ({
      ..._,
      prevLayout: _.layout,
      cateringContext: null,
      scrollX: scrollRef.current ? scrollRef.current.scrollLeft : 0,
      scrollY: scrollRef.current ? scrollRef.current.scrollTop  : 0,
      seletecCateringGroup: {
        item: menu.action,
        tailNumber: _.cateringContext?.tailNumber,
        selectedView: menu.action,
        group: groups  
      }
    }));
    return;
  }

  // ── finalize-rotation: commit API
  if (menu?.action === 'finalize-rotation') {
    setState((_) => ({ ..._, isLoadingFlights: true }));
    try {
      const status = await DFPAPIEndpoint.post('sandboxing/commit-orchestrations', {
        rotationId: cateringGroup?.groupId
      });
      if (status) {
        const { isolateName, isolateId } = status;
        setState((_) => ({ ..._, prevLayout: _.layout, cateringContext: null, isLoadingFlights: false }));
        storageUtil.set('CALENDAR_DATE_KEY', toolbar.date, 'session');
       await set('CALENDAR_FLIGHTS_KEY', JSON.parse(JSON.stringify(state.flightsRows)));
        storageUtil.set('CALENDAR_SCROLL_KEY', {
          x: scrollRef.current?.scrollLeft || 0,
          y: scrollRef.current?.scrollTop  || 0
        }, 'session');
        navigate(
          `/sales/dynamic/sector/containerIsolate/${encodeURIComponent(isolateName)}/${isolateId}`,
          { state: { viewMode: true, name: isolateName, id: isolateId } }
        );
      }
    } catch (error) {
      const parseErr = JSON.parse(error.message);
      setMessage({ error: parseErr?.data?.message || "Something went wrong. Please try again after some time." });
      loadingRef.current = setTimeout(() => {
        setState((_) => ({ ..._, loadingContexts: false, isLoadingFlights: false }));
        setMessage({ text: '' });
      }, 1800);
    }
    return;
  }

  try {
    setState((_) => ({ ..._, loadingContexts: true }));

    const getTailNumbers = (cateringGroup) => {
      let tailNumbers = [];
      cateringGroup.sectors.forEach(sec => {
        if (sec.tailNumber) {
          const tn = getCorrectedTailNo(sec.tailNumber);
          if (tn) {
            tailNumbers.push({
              tailNumber: tn,
              sector: `${sec.flightNumber}-${sec.origin}-${sec.destination}/${moment.parseZone(sec.flightDate).format('YYYY-MM-DD')}`
            });
          }
        }
      });
      return tailNumbers;
    };

    const tailNumbers = getTailNumbers(cateringGroup);
    const status = await DFPAPIEndpoint.post('operations/cateringGroups/status', {
      cateringGroupId: cateringGroup.id,
      tailNumbers: tailNumbers.length ? tailNumbers : [cateringGroup?.latestEstimate?.tailNumber].filter(Boolean)
    });

    if (status) {
      setState((_) => ({ ..._, loadingContexts: false }));
      if (menu?.action === 'invoice-menu') {
        downloadTroleyPlan(4);
      } else {
        setState((_) => ({
          ..._,
          prevLayout: _.layout,
          cateringContext: null,
          scrollX: scrollRef.current ? scrollRef.current.scrollLeft : 0,
          scrollY: scrollRef.current ? scrollRef.current.scrollTop  : 0,
          seletecCateringGroup: {
            item: menu.action,
            selectedView: menu.action,
            status,
            group: menu?.action === 'estimates' ? cateringGroup : groups
          }
        }));
      }
    } else {
      setMessage({ error: 'Catering status not available' });
      loadingRef.current = setTimeout(() => {
        setState((_) => ({ ..._, loadingContexts: false }));
        setMessage({ text: '' });
      }, 1800);
    }
  } catch (error) {
    const parseErr = JSON.parse(error.message);
    setMessage({ error: parseErr?.data?.message || "Something went wrong. Please try again after some time." });
    loadingRef.current = setTimeout(() => {
      setState((_) => ({ ..._, loadingContexts: false }));
      setMessage({ text: '' });
    }, 1800);
  }
};

  const handleMenuOpen=(isOPen)=>{
    setState(prevState => ({
      ...prevState,
      isOpenMenu: isOPen,
    }));
  }

  const checkInputFields=async()=>{
      if (!state.seletecCateringGroup) return;
  }

  return (
    <div className="ctrl-calender-container flexCol full">
      {
        !Boolean(state.seletecCateringGroup) && checkInputFields() &&
        <section className="flexCol full o-hide margTop0">
          <div ref={toolbarRef} className="flexRow alignItemsEnd justifyContentSpaceBetween" style={{minHeight: 'calc(2rem + 3px)',maxHeight: 'calc(3.5rem + 6px)'}}>
            <div className="flexRow alignItemsEnd" style={{paddingBottom:'2px'}}>
              <Input type='date' isclearable={false} value={toolbar.date} style={{width:'150px',marginLeft:'0.2rem'}} name='date' id='date' onChange={handleInputChange} aria-label="Select a date" />
          {   state?.loadingContexts || state.isLoadingFlights ? <button className="icon-undo" title='Loading'><img src={LoadingIn} style={{height:'25px',width:'25px'}} alt="Loading" /></button>:null}

            </div>

            <div className="flexRow margTop0" style={{marginRight:"2px"}}>

            { isSuperAdmin ? <>
              <button 
                title="Refresh"
                disabled={state?.isRefreshLoading || state?.isLoadingFlights}
                onClick={() => {
                  isManualRefreshRef.current = true;  // Mark as manual refresh
                  setState((_) => ({ ..._, isRefreshLoading: true }));
                  fetchFlighSchedule(); 
                }}
                style={{
                    padding: '8px',
                    cursor: state?.isRefreshLoading ? 'not-allowed' : 'pointer',
                    color: state?.isRefreshLoading ? '#4cc3e6' : '#ffffff',
                    transition: 'color 0.2s ease'
                  }}
                  onMouseEnter={(e) => {
                    if (!state?.isRefreshLoading) {
                      e.currentTarget.style.color = '#4cc3e6';  
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (!state?.isRefreshLoading) {
                      e.currentTarget.style.color = '#ffffff';  
                    }
                  }}                           
              >
                <BiRefresh size={24} style={{animation: state?.isRefreshLoading ? 'spin 1s linear infinite' : 'none'}} />
              </button>

             {downloadCalender ? <button 
                
                disabled={state?.isDownloadingFlights}
                title={state?.isDownloadingFlights ? "Downloading DFP calendar" : "Download DFP calendar"}
                onClick={() => downloadDFPCSV()}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: '8px',
                  backgroundColor: 'transparent',
                  border: 'none',
                  cursor: state?.isDownloadingFlights ? 'not-allowed' : 'pointer',
                }}
              
              >
                {state?.isDownloadingFlights
                  ? <img src={LoadingIn} alt="Downloading" style={{height: '24px', width: '24px'}} />
                  : <img src={DOWNLOAD_ICON} alt="Download" style={{height: '24px', width: '24px'}} />}
              </button> : <></>}
            </> : null }

             {toolbar && toolbar.tailNo? (<div  style={{paddingBottom:"12px"}} className='flexCol margLeft16'>
            <Select
              options={tailNumber}
              defaultValue={toolbar.tailNo[0]?.label ? toolbar.tailNo[0]?.label : ''}
              value={tailNumber?.filter(function (option) {
                return (
                  toolbar.tailNo.length && toolbar.tailNo[0]&&
                  toolbar.tailNo.find((sc) => sc.label === option.label)
                );
              })}
              onChange={handletailNumberSel}
              styles={customStyles}
              isOpenMenu={state.isOpenMenu}
              onMenuOpen={() => handleMenuOpen(true)}
              onMenuClose={() => handleMenuOpen(false)}
              placeholder="Search Tail Number"
              isSearchable={true}
              isClearable={true}
              className="select-menu-dfp-filter"
            />
          </div>):<></>}

       
          {toolbar && toolbar.baseStn? (<div className='flexCol margLeft16'>
            <Select
              options={storesList}
              defaultValue={toolbar.baseStn[0]?.label ? toolbar.baseStn[0]?.label : ''}
              value={storesList?.filter(function (option) {
                return (
                  toolbar.baseStn.length && toolbar.baseStn[0]&&
                  toolbar.baseStn.find((sc) => sc.label === option.label)
                );
              })}
              onChange={handleBaseStaationSel}
              styles={customStyles}
              isOpenMenu={state.isOpenMenu}
              onMenuOpen={() => handleMenuOpen(true)}
              onMenuClose={() => handleMenuOpen(false)}
              placeholder="Search Catering Airport"
              isSearchable={true}
              isClearable={true}
              className="select-menu-dfp-filter"
            />
          </div>):<></>}

              <ToastContainer />

              {/* <Input type='select' className="group-by" style={{width:'150px'}} value={toolbar.groupBy} name='groupBy' options={GroupingModes} onChange={handleInputChange} aria-label="Group By" /> */}
              <Input type='select' className="group-by" value={toolbar.timezone} name='timezone' options={state.timeZone} onChange={handleInputChange} />
            </div>
          </div>
          <div className="flexCol full-flex o-hide" ref={tblRef}>
            {
              Boolean(state.layout) &&
              <div className="flexCol dfpTable full tabl-cntr dynamicBorder" ref={scrollRef} 

              style={{ width: `${state.layout.width}px`, height: `${state.layout.height}px`}}>
             
                <div className="hover-time-line" ref={hoverLineRef}>
                  <span ref={hoverTooltipRef} className="hover-time-tooltip"></span>
                </div>
          {(state.flightsRows.length)&&(!state.noDataShow)?
                      
                  <table className={`tbl ${state.isLoadingFlights?`load-tblDfp`:`tblDfp`}`}>
                    <thead>
                      <tr>
                        <th className="fixed fixedHeader">
                          <div className="head-cell">{toolbar.groupBy === "Catering Airport"?"Catering Airport":"Tail No."}</div>
                        </th>
                        <th className="fixed tail">
                          <div className="head-cell">{toolbar.groupBy === "Catering Airport"?"Tail No.":"Catering Airport"}</div>
                        </th>
                        {
                          getTimeColumns().map((_) => {
                            return <th key={_.value}>
                        <div className={`head-cell${_.value > 23 ? '-extra-hours' : ''}`}>{_.value > 23 ? `+${_.label}` : _.label}</div>
                              </th>
                          })                       
                        }
                      </tr>
                    </thead>
                    <tbody>
                      {viewcalender && editDFpcalender?
                        state.flightsRows.map((row, i) => {
                          return (
                            <tr key={i} >
                              {
                                Boolean(row.primary) &&
                                <td className="fixed group-cell" rowSpan={row.primary.count}>
                                  <div className="cell flexCol alignItemsCenter justifyContentCenter station" onClick={() => handleDialog('station')}>{row.primary.label}</div>
                                </td>
                              }
                              {
                                Boolean(row.tail) &&
                                <td className="fixed group-cell tail">
                                  <div className="cell flexCol alignItemsCenter justifyContentCenter station" onClick={() => handleDialog('station')}>{row.tail.group}</div>
                                </td>
                              }
                              <td className="flight-layer" style={{ padding: 0, border: 'none' }}>
                                    {
                                Boolean(row.flights) &&
                                <React.Fragment>
                                  {
                                    row.flights?.map((flight, j) => {
                                      return (
                                        <div
                                          key={j} className="flight" style={{ left: `${flight.left}px`, width: `${flight.width}px` }}
                                          onContextMenu={handleContextMenu.bind(null, flight, row)}
                                          onClick={() => handleDialog('leg')} title={flight.item?.key}>
                                          {flight.item?.key}
                                        </div>
                                      )
                                    })
                                  }
                                </React.Fragment>
                              }
                              {
                                Boolean(row.catGroups) &&
                                <React.Fragment>
                                  {
                                 row.catGroups.map((cat, j) => {
                                        const jobStatus = cat.item?.commitOrchestrationJob?.status;
                                        const jobMeta = jobStatus ? getCommitJobMeta(cat.item?.commitOrchestrationJob) : null;
                                        const statusClass = jobStatus ? `status-${jobStatus}` : '';

                                        return (
                                          <div
                                            key={j}
                                            className={`flight ${cat.item.baseGroup ? 'cat-group-non-base' : cat.item.widthAdj ? 'cat-group-non-base-adj' : 'cat-group'} ${statusClass}`}
                                            style={{ left: `${cat.left}px`, width: `${cat.width}px` }}
                                            onContextMenu={handleCateringContextMenu.bind(null, row.catGroups, j, row.tail.group)}
                                            title={cat.item?.groupName}
                                          >
                                            {cat.item.baseGroup ? "\u200B" : (
                                              <>
                                                {jobMeta && (
                                                  <span 
                                                  title={`${jobMeta.label}`}
                                                  className={`cat-status-icon status-${jobStatus}`}>
                                                    {jobMeta.icon}
                                                  </span>
                                                )}
                                                <span className="cat-group-label">
                                                  {cat.item?.groupName}
                                                </span>
                                              </>
                                            )}
                                          </div>
                                        );
                                      })
                                      }
                                </React.Fragment>
                              }
                              </td>
                          

                            </tr>
                          )
                        }):null
                      }
                    </tbody>

                  </table>:<table className="tbl">
                    <thead>
                      <tr>
                        <th className="fixed">
                          <div className="head-cell">Catering Airport</div>
                        </th>
                        <th className="fixed tail">
                          <div className="head-cell">Tail No.</div>
                        </th>
                        {
                          getTimeColumns().map((_) => {
                          return <th key={_.value}>
                        <div className={`head-cell${_.value > 23 ? '-extra-hours' : ''}`}>{_.value > 23 ? `+${_.label}` : _.label}</div>
                              </th>
                          })
                        }
                      </tr>
                    </thead>
                    <tbody>
                   <></>
                    </tbody>

                  </table>}

              </div>
            }
          </div>
        </section>
      }
     

      {Boolean(state.cateringContext) &&
  <div className="ctrl-container-merge-menu"
    style={{ top: state.cateringContext.points.y, left: state.cateringContext.points.x }}>
    <ul>
      {(state.cateringContext?.sector && !state.cateringContext?.filteredGroups
        ? getFlightContextMenuItems()
        : getCateringContextMenuItems()
      ).map((menuItem, index) => (
        <li
          key={index}
          onClick={()=>handleCateringClick(menuItem)}
          style={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'center', 
            gap: '1rem',
            cursor: 'pointer' 
          }}
        >
          <span>{menuItem.label}</span>
        </li>
      ))}
    </ul>
  </div>
}
      {
        Boolean(state.seletecCateringGroup) &&
        <CalendarCateringScreen
          {...state.seletecCateringGroup}
          getCorrectedTailNo={getCorrectedTailNo}
          defaultTimezone={state?.defaultTimeZone}
          timezone={toolbar.timezone}
         onBack={() => {
          setState((_) => ({
            ..._,
            layout: _.prevLayout,
            seletecCateringGroup: null,
            restoreScroll: true
          }))
        }}
        />
      }
    </div>
  );
};







